import React from "react";
import ReactDOM from "react-dom/client";
import "antd/dist/antd.css";
import App from "./App";
import "mapbox-gl/dist/mapbox-gl.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import mixpanel from "mixpanel-browser";

import { getEnvironment } from "./utilities";

Sentry.init({
  dsn: "https://4dad25346767477d8f32fcc5a00019cd@o4503952839999488.ingest.sentry.io/4503952842686464",
  integrations: [new BrowserTracing()],
  environment: getEnvironment(),

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

mixpanel.init("93594017d16b761ec85db402e790dedf");
mixpanel.register({
  environment: getEnvironment(),
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
